module.exports = __webpack_public_path__ + "static/media/IMG-1.8c3ffcf2.jpg";